/*
 * Warmoura cart behaviour.
 *
 * Dawn already owns cart mutation, section rendering, the drawer focus trap and
 * the aria-live announcements. This file only adds what that does not cover:
 * the two-column pull-up measurement on the cart page, a loading state while a
 * line updates, and a guard against double submission.
 */
(() => {
  const DESKTOP = '(min-width: 990px)';

  // The cart summary is a separate Shopify section, so its column position is
  // measured from the item list rather than assumed.
  const alignSummary = () => {
    const summary = document.querySelector('.warmoura-cart-summary');
    const lines = document.querySelector('.warmoura-cart-page__lines');
    if (!summary || !lines) return;
    if (!window.matchMedia(DESKTOP).matches) {
      summary.style.removeProperty('--wc-summary-offset');
      return;
    }
    const offset = lines.getBoundingClientRect().height + 24;
    summary.style.setProperty('--wc-summary-offset', `${Math.max(0, Math.round(offset))}px`);
  };

  // A line being changed is dimmed so the customer can see which row is busy.
  const markUpdating = (event) => {
    const line = event.target.closest('.warmoura-cart-item');
    if (line) line.classList.add('is-updating');
  };

  const clearUpdating = () => {
    document.querySelectorAll('.warmoura-cart-item.is-updating').forEach((line) => {
      line.classList.remove('is-updating');
    });
  };

  // Checkout submits a real form, so a second press would post twice.
  const guardSubmit = (event) => {
    const button = event.target.closest('button[name="checkout"]');
    if (!button) return;
    if (button.dataset.submitting === 'true') {
      event.preventDefault();
      return;
    }
    button.dataset.submitting = 'true';
    button.classList.add('is-loading');
    // Released if the page is restored from the back/forward cache.
    window.setTimeout(() => {
      button.dataset.submitting = 'false';
      button.classList.remove('is-loading');
    }, 8000);
  };

  const bind = () => {
    alignSummary();
    document.removeEventListener('change', markUpdating, true);
    document.addEventListener('change', markUpdating, true);
    document.removeEventListener('click', guardSubmit, true);
    document.addEventListener('click', guardSubmit, true);
  };

  document.addEventListener('DOMContentLoaded', bind);
  if (document.readyState !== 'loading') bind();

  window.addEventListener('resize', alignSummary);
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('button[name="checkout"]').forEach((button) => {
      button.dataset.submitting = 'false';
      button.classList.remove('is-loading');
    });
  });

  // Dawn publishes this after every cart mutation and section re-render.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      clearUpdating();
      window.requestAnimationFrame(alignSummary);
    });
  }
})();
